// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Image_Toolbar__1BRWb","Fullscreen":"Image_Fullscreen__2L2Pb"};